import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Toolbar from '@material-ui/core/Toolbar'

const style = theme => ({
  flex: {
    flex: 1
  },
  icon: {
    paddingRight: '20px'
  }
})

const ItemSummary = ({ classes, title, value, label}) => {
  return (
    <Toolbar>
      <div className={classes.flex}>
        <Typography>
          {title}
        </Typography>
      </div>
      <div className={classes.flex}>
        <Typography>
          {value}
        </Typography>
      </div>
    </Toolbar>
  )
}

export default withStyles(style)(ItemSummary)



// WEBPACK FOOTER //
// ./src/components/ItemSummary.js